import { render } from "./DefaultField.vue?vue&type=template&id=71339deb"
import script from "./DefaultField.vue?vue&type=script&lang=js"
export * from "./DefaultField.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DefaultField.vue"]])

export default __exports__